'use client';

import { useProductFeatures } from '@/providers/ProductFeaturesProvider';
import { NavGroup } from '@/config/navigation';
import { usePermissions } from '@/hooks/usePermissions';
import { SidebarNavItem } from './sidebar-nav-item';

interface SidebarGroupProps {
  group: NavGroup;
  collapsed: boolean;
  onItemClick?: () => void;
}

export function SidebarGroup({ group, collapsed, onItemClick }: SidebarGroupProps) {
  const { can } = usePermissions();
  const { isFeatureEnabled } = useProductFeatures();

  const visibleItems = group.items.filter((item) => {
    if (item.enabled === false) return false;
    if (item.featureFlag) {
      const featureOn = isFeatureEnabled(item.featureFlag);
      console.log(
        `[Sidebar] item="${item.id}" featureFlag="${item.featureFlag}" enabled=${featureOn}`
      );
      if (!featureOn) return false;
    }
    if (item.permission && !can(item.permission.resource, item.permission.action)) return false;
    return true;
  });

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <div role="group" aria-label={group.label}>
      {/* Section title (expanded) or separator (collapsed) */}
      {group.label && !collapsed && (
        <div className="px-3 pb-1.5 pt-2">
          <span className="text-foreground/80 text-xs font-semibold uppercase tracking-wider">
            {group.label}
          </span>
        </div>
      )}
      {group.label && collapsed && (
        <div className="mx-2 my-2">
          <div className="bg-border h-px" />
        </div>
      )}
      <div className="space-y-0.5">
        {visibleItems.map((item) => (
          <SidebarNavItem key={item.id} item={item} collapsed={collapsed} onClick={onItemClick} />
        ))}
      </div>
    </div>
  );
}
